import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider, connectAuthEmulator, signInWithEmailAndPassword } from "firebase/auth";
import { initializeFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const firebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
// ignoreUndefinedProperties: 임포트 데이터(Partial<Student>)의 undefined 필드가 batch.set 전체를 거부시키는 걸 막는다
export const db = initializeFirestore(firebaseApp, { ignoreUndefinedProperties: true });
export const storage = getStorage(firebaseApp);
export const functions = getFunctions(firebaseApp, "asia-northeast3");
// 시험용: `VITE_USE_EMULATOR=1`로 띄우면 운영 대신 로컬 에뮬레이터(auth·firestore·functions·storage)에 붙는다. 운영 빌드에는 이 값이 없다.
if (import.meta.env.VITE_USE_EMULATOR === "1") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
  // 시험 자동화용 — 팝업 없이 이메일·비밀번호로 에뮬레이터 계정에 들어간다(운영 빌드에는 없음)
  (window as unknown as { __emuSignIn?: (e: string, p: string) => Promise<unknown> }).__emuSignIn = (e, p) => signInWithEmailAndPassword(auth, e, p);
}
export const googleProvider = new GoogleAuthProvider();
// "다른 구글 계정으로 로그인"을 눌렀을 때 같은 계정이 자동으로 다시 잡히지 않게 계정 선택창을 띄운다
googleProvider.setCustomParameters({ prompt: "select_account" });

export const isFirebaseConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);
